import { TextTestID } from "@/constants/TestID";
import { Accordion, Text } from "@/ui/core";
import { Box } from "@/ui/layout";
import { LayoutToken } from "@/ui/theme/tokens";
import { joinTestIDs } from "@/utils/string.util";

interface InformationalAccordionProps extends ViewWithTestID {
  description: string;
  onTriggerPress: (isOpen: boolean) => void;
  shouldDefaultToOpen?: boolean;
  title: string;
}

const InformationalAccordion = ({
  description,
  onTriggerPress,
  shouldDefaultToOpen = false,
  testID,
  title,
}: InformationalAccordionProps) => {
  return (
    <Box
      paddingHorizontal={LayoutToken.ContentPaddingHorizontal}
      paddingTop={LayoutToken.ContentPaddingHorizontal}
      testID={joinTestIDs(testID, "informational-accordion")}
    >
      <Accordion
        onTriggerPress={onTriggerPress}
        shouldDefaultToOpen={shouldDefaultToOpen}
        testID={testID}
        title={title}
      >
        <Box paddingRight={18}>
          <Text testID={joinTestIDs(testID, TextTestID.Description)}>
            {description}
          </Text>
        </Box>
      </Accordion>
    </Box>
  );
};
export type { InformationalAccordionProps };
export default InformationalAccordion;
